<template>
  <div class="oi-container">
    <div class="oi-wrapper">
      <div
        v-for="(items, index) in orders.info"
        :key="index"
        class="pic-title-price"
      >
        <div class="pic-title-price-container">
          <div class="pic-title">
            <img
              class="meal-icon"
              :src="
                items.drinkImg
                  ? items.drinkImg
                  : '../../../../static/img/user/pic_home_default.png'
              "
              @error="errorLoadImg()"
            />
            <span class="meal-name-count">
              <span class="name">{{ items.drinkName }}</span>
              <span class="count">{{ items.info }}</span>
              <span class="count">数量：{{ items.amount }}</span>
            </span>
          </div>
          <div class="price">总价：¥{{ items.prize }}</div>
        </div>
      </div>
    </div>
    <div class="operation">
      <span
        v-if="this.orders.status === 1"
        @click="cancelOrders"
        class="cancel-order"
        >{{ cancelText }}</span
      >
      <span v-if="this.orders.status !== 1" class="comment">--</span>
    </div>
  </div>
</template>

<script>
import { Modal } from "ant-design-vue";
import "ant-design-vue/lib/tabs/style/css";
export default {
  name: "CoffeeBlock",
  props: {
    orders: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      isCancel: false,
    };
  },
  computed: {
    commentText() {
      return this.orders.is_discuss === 1 ? "评价" : "已评价";
    },
    cancelText() {
      return this.isCancel ? "撤销订单中..." : "撤销订单";
    },
  },
  methods: {
    /**
     * 当订单未评价时，弹出评价弹窗
     */
    showOrderComment() {
      if (this.orders.is_discuss === 1) {
        this.$store.commit("set_comment_need_data", this.orders);
        this.$store.commit("toggle_show_order_comment");
      } else {
        this.$store.commit("show_alert", "该订单已经被评价了呦");
      }
    },
    /**
     * 撤销订单
     */
    cancelOrders() {
      Modal.confirm({
        title: "提示",
        content: "商家正准备接单，确定取消订单 ?",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.isCancel = true;
          this.axios
            .post("/drinks/order/cancelOrderByCustomer", {
              orderNum: this.orders.orderNum,
            })
            .then((res) => {
              this.isCancel = false;
              if (res.code === 0) {
                this.$store.commit("show_alert", "撤销订单成功");
                this.$emit("getOrders", "child");
              } else {
                this.$store.commit("show_alert", "撤销订单失败");
              }
            })
            .catch(() => {
              this.isCancel = false;
              this.$store.commit("show_alert", "撤销订单失败");
            });
        },
      });
    },
    /**
     * 如果图片加载出错，显示默认图片
     */
    errorLoadImg() {
      const eventTag = event.toElement || event.target;
      eventTag.src = "../../../static/img/user/pic_home_default.png";
    },
  },
};
</script>

<style lang="less" scoped>
.oi-container {
  width: 902px;
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  .oi-wrapper {
    display: flex;
    flex-direction: column;
    .pic-title-price {
      display: flex;
      flex-direction: column;
      border: solid 1px #e0e0e0;
      border-top: 0;
      .pic-title-price-container {
        width: 739px;
        height: 134px;
        display: flex;
        .pic-title {
          width: 578px;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-right: solid 1px #e0e0e0;
          .meal-icon {
            width: 90px;
            height: 90px;
            margin-left: 20px;
            border-radius: 6px;
          }
          .meal-name-count {
            display: flex;
            flex-direction: column;
            margin-left: 10px;
            .name {
              font-size: 16px;
              color: #333333;
            }
            .count {
              font-size: 14px;
              color: #999999;
              margin-top: 15px;
            }
          }
        }
        .price {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .operation {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: solid 1px #e0e0e0;
    border-bottom: solid 1px #e0e0e0;
    .cancel-order {
      font-size: 16px;
      color: #fe4c4c;
      cursor: pointer;
    }
    .comment {
      font-size: 16px;
      //   color: #ff9a28;
      //   cursor: pointer;
    }
    .commented {
      color: #999999;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coffee/components/CoffeeBlock.vue